import { Component, Input, OnInit } from "@angular/core";
import { BreadcrumbModel } from "@modules/common/models/BreadcrumbModel";
import { RefreshDataBreadcrumbsService } from '@modules/data-refresh-shared/services/refresh-data-breadcrumbs.service';

@Component({
    selector: 'app-refresh-data-header',
    templateUrl: './refresh-data-header.component.html',
    styleUrls: ['./refresh-data-header.component.scss']
})
export class RefreshDataHeaderComponent implements OnInit {
    @Input()
    public pageName?: string;

    @Input()
    public currentRoute?: string;

    public breadcrumbsModel!: BreadcrumbModel[];

    constructor(private _refreshDataBreadcrumbsService: RefreshDataBreadcrumbsService) { }

    ngOnInit(): void {
        this.breadcrumbsModel = this._refreshDataBreadcrumbsService.getBreadcrumbsModel({
            basePageTitle: 'Data Refresh',
            basePageLocation: 'RefreshDataHistory',
            currentPageTitle: this.pageName,
            currentPageRouteName: this.currentRoute
        });
    }
}
